var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDj({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.256 421.59L256 256 3.256 90.41C1.311 92.029 0 94.375 0 97.103v317.793c0 2.729 1.311 5.075 3.256 6.694z",
    fill: "#f5f5f5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.256 421.59c1.53 1.274 3.425 2.134 5.571 2.134h494.345a8.829 8.829 0 0 0 8.828-8.828V256H256L3.256 421.59z",
    fill: "#73af00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.256 90.41c1.53-1.274 3.425-2.134 5.571-2.134h494.345A8.829 8.829 0 0 1 512 97.104V256H256L3.256 90.41z",
    fill: "#82afff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M91.766 216.135l-8.94 26.806-28.257.22c-1.549.012-2.191 1.99-.946 2.91l22.732 16.787-8.523 26.942c-.467 1.478 1.215 2.699 2.475 1.798l22.989-16.431 22.989 16.431c1.26.9 2.942-.321 2.475-1.798l-8.523-26.942 22.729-16.788c1.246-.92.604-2.898-.946-2.91l-28.257-.22-8.94-26.806c-.488-1.469-2.567-1.469-3.057.001z",
    fill: "#ff4b55"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDj);
export default __webpack_public_path__ + "static/media/dj.2116f248182f47e278449c1332c2558b.svg";
export { ForwardRef as ReactComponent };